export default __webpack_public_path__ + "static/30_Years_Seal_Gray_final-b7deb50b7484cbe8ed73e9874d118919.png";